module.exports = __webpack_public_path__ + "static/media/Декларация за корпоративно управление_2019.7743ce02.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Декларация за корпоративно управление_2019.pdf
// module id = 120
// module chunks = 0